import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import classnames from 'classnames';
import { FormField, LabelPlacement } from '../form-field/form-field';

export type SliderProps = {
  label: React.ReactNode;
  min?: number;
  max?: number;
  step?: number;
  labelPlacement?: LabelPlacement;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Slider = forwardRef(
  (
    {
      className,
      label,
      min = 0,
      max = 100,
      step = 1,
      labelPlacement = 'left',
      ...inputProps
    }: SliderProps,
    ref: React.Ref<HTMLInputElement | null>
  ) => {
    const classNames = classnames(className, 'airtame-slider');
    const internalRef = useRef<HTMLInputElement>(null);
    // Expose the internal ref as the forwarded ref
    useImperativeHandle(ref, () => internalRef.current);

    useEffect(() => {
      if (internalRef.current) {
        internalRef.current.style.backgroundSize = `${
          ((internalRef.current.valueAsNumber - min) / (max - min)) * 100
        }% 100%, 100%`;
      }
    });
    return (
      <FormField className={classNames} label={label} labelPlacement={labelPlacement}>
        <input
          {...inputProps}
          type="range"
          min={min}
          max={max}
          step={step}
          className="airtame-slider__input"
          ref={internalRef}
        />
      </FormField>
    );
  }
);

Slider.displayName = 'Slider';
